import { createAction } from '@reduxjs/toolkit';
import { SharedUserConfig } from 'app/interfaces/SharedUserConfiguration';

export const SHARED_USER_CONFIG_LOADED = 'SHARED_USER_CONFIG_LOADED' as const;

export const loadSharedUserConfig = createAction<
  SharedUserConfig,
  typeof SHARED_USER_CONFIG_LOADED
>(SHARED_USER_CONFIG_LOADED);

export type LoadSharedUserConfigAction = ReturnType<typeof loadSharedUserConfig>;
